import { uniqueString } from '../utils/string'

const _maxSize = uniqueString('Queue_maxSize')
const _queue = uniqueString('Queue_queue')

export default class Queue {
  constructor(maxSize = Infinity) {
    this[_queue] = []
    this[_maxSize] = Number(maxSize)
  }

  get size() {
    return this[_queue].length
  }

  get empty() {
    return this[_queue].length === 0
  }

  get front() {
    return this[_queue][0]
  }

  enqueue(element) {
    if (this.size >= this[_maxSize]) return

    this[_queue].push(element)
  }

  dequeue() {
    return this[_queue].shift()
  }

  clear() {
    this[_queue] = []
  }
}
